import { useState } from 'react';
import { maskCpf, maskDate, maskPhone } from './mask';

export const useGenericFormValidator = (initialForm, validationRules = {}) => {
    const [form, setForm] = useState(initialForm);
    const [errors, setErrors] = useState({});

    const validate = (fieldValues = form) => {
        const tempErrors = { ...errors };

        Object.keys(fieldValues).forEach((field) => {
            const value = fieldValues[field];
            const rules = validationRules[field];

            if (rules?.required && !value) {
                tempErrors[field] = 'Campo obrigatório';
            } else if (rules?.pattern && !rules.pattern.test(value)) {
                tempErrors[field] = rules.message || 'Formato inválido';
            } else if (rules?.custom && typeof rules.custom === 'function') {
                const customMessage = rules.custom(value, form);
                if (customMessage) tempErrors[field] = customMessage;
                else delete tempErrors[field];
            } else {
                delete tempErrors[field];
            }
        });

        setErrors(tempErrors);

        return Object.values(tempErrors).every((x) => x === '' || x === true);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        var newValue =
            name == "cpf"
                ? maskCpf(value)
                : name == "phone"
                    ? maskPhone(value)
                    : name == "dateOfBirth"
                        ? maskDate(value)
                        : value;

        const updatedForm = { ...form, [name]: newValue };
        setForm(updatedForm);
        validate({ [name]: value });
    };

    return {
        form,
        errors,
        handleChange,
        validate,
        setForm,
        setErrors,
    };
};
